"use strict";
// @ts-ignore
try {
    self['workbox:strategies:5.0.0-rc.1'] && _();
}
catch (e) { }
